import styles from './styles.mod.scss';
import utilStyles from '../utils.mod.scss';
import React from 'react';
import classnames from 'classnames';
import LoadingSpinner from 'scy/LoadingSpinner';
import { PrimaryButton as DefaultButton } from 'scy/buttons';

export default function LoadingButton({
  Button = DefaultButton,
  disabled,
  loading,
  className,
  children,
  ...rest
}) {
  return (
    <Button
      {...rest}
      disabled={disabled || loading}
      className={classnames(
        styles.loadingButton,
        {
          [styles.loading]: loading
        },
        className
      )}
    >
      <span className={loading ? utilStyles.hidden : null}>{children}</span>
      {loading && <LoadingSpinner />}
    </Button>
  );
}
